// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.community-list-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 24px;
  width: 100%;
}

.community-view {
  padding: 10px;
}

/* Header */
.communities-header {
  margin-bottom: 32px;
}

.communities-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 16px 0;
}

.communities-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  position: relative;
}

.sort-controls {
  display: flex;
  gap: 8px;
}

.sort-dropdown {
  display: none;
  padding: 8px 12px;
  border-radius: 20px;
  background: var(--hover-bg);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}

.sort-dropdown:hover {
  background: var(--primary-color);
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.12);
}

.sort-dropdown:focus {
  outline: none;
  background: var(--primary-color);
}

.sort-dropdown option {
  background: var(--bg-primary);
  color: var(--text-primary);
}

.view-controls {
  display: flex;
  gap: 8px;
}

/* Right-aligned layout selector (matches Settings page styles) */
.view-controls.layout-selector {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  width:100%;
}

.layout-selector-label {
  font-size: 0.95rem;
  color: var(--text-secondary);
  margin-bottom: 6px;
}

.communities-header .view-controls.layout-selector .flux-grid {
  display: flex;
  gap: 8px;
}

.communities-header .view-controls.layout-selector .layout-card {
  padding: 2px 3px;
  min-width: 62px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

/* Use the same smaller preview size as Settings */
.communities-header .flux-preview.preview-small {
  height: 44px;
  padding: 6px;
  gap: 4px;
}

/* Display settings inline button (appears with sort-controls) */
.display-settings-btn {
  margin-left: 8px;
  position: absolute;
  right: 0;
  padding: 8px 12px;
  border-radius: 20px;
  background: var(--hover-bg);
  color: var(--text-primary);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  border: 1px solid var(--border-color);
}

.display-settings-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0,0,0,0.12);
  background: var(--primary-color);
}

.display-settings-btn .display-label {
  font-size: 13px;
}

.display-settings-btn .arrow {
  display: inline-block;
  transition: transform 0.3s ease;
  font-size: 16px;
  line-height: 17px;
}

.display-settings-btn .arrow.open,
.display-settings-btn.open .arrow {
  transform: rotate(180deg);
}

/* Panel with flux-grid displayed when toggled */
.display-settings-panel {
  margin-top: 12px;
  margin-bottom: 18px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.display-settings-panel .layout-card {
  padding: 10px;
  min-width: 110px;
}

/* Make sure panel looks good on small screens */
@media (max-width: 768px) {
  .display-settings-panel {
    flex-direction: column;
    gap: 8px;
  }

  .display-settings-btn {
    margin-top: 8px;
  }
}


.communities-header 

.view-btn {
  padding: 8px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.view-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.view-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.sort-btn {
  padding: 8px 16px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
}

.sort-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.sort-btn.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.sort-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Communities Grid */
.communities-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.communities-grid.list-view {
  grid-template-columns: 1fr;
}

.community-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s;
}

.community-card.list-view {
  width: 100%;
}

.community-card:hover {
  border-color: var(--primary-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.community-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.community-card-name {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  word-break: break-word;
}

.nsfw-badge {
  padding: 2px 8px;
  background: #ff4444;
  color: white;
  font-size: 11px;
  font-weight: 700;
  border-radius: 4px;
  flex-shrink: 0;
}

.community-card-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  line-height: 1.4;
}

.community-card-description {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.5;
  margin: 0;
}

.community-card-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
}

.stat {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: var(--text-secondary);
}

.stat svg {
  width: 16px;
  height: 16px;
  color: var(--text-secondary);
}

.community-card-admins {
  font-size: 12px;
  color: var(--text-secondary);
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
}

.admins-label {
  font-weight: 600;
  margin-right: 4px;
}

.admins-list {
  color: var(--text-primary);
}

.community-sub-btn {
  align-self: flex-end;
  margin-top: auto;
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  border: 1.5px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
}

.community-sub-btn:hover:not(:disabled) {
  background: var(--primary-color);
  color: var(--text-primary);
}

.community-sub-btn.subscribed {
  border-color: var(--border-color);
  color: var(--text-secondary);
}

.community-sub-btn.subscribed:hover:not(:disabled) {
  border-color: var(--error-color);
  color: var(--error-color);
  background: transparent;
}

.community-sub-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.community-sub-btn-spinner {
  width: 12px;
  height: 12px;
  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  animation: community-sub-btn-spin 0.7s linear infinite;
}

@keyframes community-sub-btn-spin {
  to {
    transform: rotate(360deg);
  }
}

.communities-empty {
  padding: 16px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  color: var(--text-secondary);
  margin-bottom: 24px;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  padding: 60px 20px;
}

/* Load More */
.load-more-container {
  display: flex;
  justify-content: center;
  padding: 20px;
}

.load-more-communities-btn {
  padding: 12px 32px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.load-more-communities-btn:hover {
  background: var(--primary-hover);
}

/* Responsive Design */
@media (max-width: 1215px) {
  .sort-controls > button:not(.display-settings-btn) {
    display: none;
  }

  .sort-dropdown {
    display: block;
  }
}

@media (max-width: 1100px) and (min-width: 769px) {
  .communities-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .communities-grid.list-view {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .community-list-container {
    padding: 16px;
  }

  .communities-header {
    margin-bottom: 24px;
  }

  .communities-title {
    font-size: 24px;
  }

  .communities-controls {
    align-items: flex-start;
  }

  .communities-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .community-card {
    padding: 16px;
  }
}

/* Search Input Styling */
.community-search-container {
  padding: 1rem 1rem 0 1rem;
}

.community-search-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--border-color, #333);
  border-radius: 8px;
  background: var(--bg-secondary, #1a1a1a);
  color: var(--text-primary, #fff);
  font-size: 1rem;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.community-search-input:focus {
  outline: none;
  border-color: var(--accent-color, #e31337);
  box-shadow: 0 0 0 2px rgba(227, 19, 55, 0.2);
}

`, "",{"version":3,"sources":["webpack://./src/components/CommunityList/CommunityList.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;AACV;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uDAAuD;EACvD,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;;EAGE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6DAA6D;EAC7D,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,kBAAkB;EAClB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,qCAAqC;EACrC,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,4CAA4C;AAC9C","sourcesContent":[".community-list-container {\r\n  max-width: 100%;\r\n  margin: 0 auto;\r\n  padding: 24px;\r\n  width: 100%;\r\n}\r\n\r\n.community-view {\r\n  padding: 10px;\r\n}\r\n\r\n/* Header */\r\n.communities-header {\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.communities-title {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 16px 0;\r\n}\r\n\r\n.communities-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  position: relative;\r\n}\r\n\r\n.sort-controls {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.sort-dropdown {\r\n  display: none;\r\n  padding: 8px 12px;\r\n  border-radius: 20px;\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n  border: 1px solid var(--border-color);\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  font-family: inherit;\r\n}\r\n\r\n.sort-dropdown:hover {\r\n  background: var(--primary-color);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px rgba(0,0,0,0.12);\r\n}\r\n\r\n.sort-dropdown:focus {\r\n  outline: none;\r\n  background: var(--primary-color);\r\n}\r\n\r\n.sort-dropdown option {\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.view-controls {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n/* Right-aligned layout selector (matches Settings page styles) */\r\n.view-controls.layout-selector {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 8px;\r\n  width:100%;\r\n}\r\n\r\n.layout-selector-label {\r\n  font-size: 0.95rem;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.communities-header .view-controls.layout-selector .flux-grid {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.communities-header .view-controls.layout-selector .layout-card {\r\n  padding: 2px 3px;\r\n  min-width: 62px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n/* Use the same smaller preview size as Settings */\r\n.communities-header .flux-preview.preview-small {\r\n  height: 44px;\r\n  padding: 6px;\r\n  gap: 4px;\r\n}\r\n\r\n/* Display settings inline button (appears with sort-controls) */\r\n.display-settings-btn {\r\n  margin-left: 8px;\r\n  position: absolute;\r\n  right: 0;\r\n  padding: 8px 12px;\r\n  border-radius: 20px;\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n  font-weight: 700;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.display-settings-btn:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 6px 16px rgba(0,0,0,0.12);\r\n  background: var(--primary-color);\r\n}\r\n\r\n.display-settings-btn .display-label {\r\n  font-size: 13px;\r\n}\r\n\r\n.display-settings-btn .arrow {\r\n  display: inline-block;\r\n  transition: transform 0.3s ease;\r\n  font-size: 16px;\r\n  line-height: 17px;\r\n}\r\n\r\n.display-settings-btn .arrow.open,\r\n.display-settings-btn.open .arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Panel with flux-grid displayed when toggled */\r\n.display-settings-panel {\r\n  margin-top: 12px;\r\n  margin-bottom: 18px;\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.display-settings-panel .layout-card {\r\n  padding: 10px;\r\n  min-width: 110px;\r\n}\r\n\r\n/* Make sure panel looks good on small screens */\r\n@media (max-width: 768px) {\r\n  .display-settings-panel {\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  .display-settings-btn {\r\n    margin-top: 8px;\r\n  }\r\n}\r\n\r\n\r\n.communities-header \r\n\r\n.view-btn {\r\n  padding: 8px 16px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.view-btn:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.view-btn.active {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.sort-btn {\r\n  padding: 8px 16px;\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 20px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.sort-btn:hover {\r\n  background: var(--hover-bg);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.sort-btn.active {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.sort-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Communities Grid */\r\n.communities-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 32px;\r\n}\r\n\r\n.communities-grid.list-view {\r\n  grid-template-columns: 1fr;\r\n}\r\n\r\n.community-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 20px;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  text-decoration: none;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.community-card.list-view {\r\n  width: 100%;\r\n}\r\n\r\n.community-card:hover {\r\n  border-color: var(--primary-color);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.community-card-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.community-card-name {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  word-break: break-word;\r\n}\r\n\r\n.nsfw-badge {\r\n  padding: 2px 8px;\r\n  background: #ff4444;\r\n  color: white;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.community-card-title {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  margin: 0;\r\n  line-height: 1.4;\r\n}\r\n\r\n.community-card-description {\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.community-card-stats {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 16px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.stat {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.stat svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.community-card-admins {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.admins-label {\r\n  font-weight: 600;\r\n  margin-right: 4px;\r\n}\r\n\r\n.admins-list {\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-sub-btn {\r\n  align-self: flex-end;\r\n  margin-top: auto;\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 16px;\r\n  border-radius: 20px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\r\n  border: 1.5px solid var(--primary-color);\r\n  background: transparent;\r\n  color: var(--primary-color);\r\n}\r\n\r\n.community-sub-btn:hover:not(:disabled) {\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n}\r\n\r\n.community-sub-btn.subscribed {\r\n  border-color: var(--border-color);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.community-sub-btn.subscribed:hover:not(:disabled) {\r\n  border-color: var(--error-color);\r\n  color: var(--error-color);\r\n  background: transparent;\r\n}\r\n\r\n.community-sub-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.community-sub-btn-spinner {\r\n  width: 12px;\r\n  height: 12px;\r\n  border: 2px solid currentColor;\r\n  border-right-color: transparent;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  animation: community-sub-btn-spin 0.7s linear infinite;\r\n}\r\n\r\n@keyframes community-sub-btn-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.communities-empty {\r\n  padding: 16px;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  color: var(--text-secondary);\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Loading */\r\n.loading-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n}\r\n\r\n/* Load More */\r\n.load-more-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 20px;\r\n}\r\n\r\n.load-more-communities-btn {\r\n  padding: 12px 32px;\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 24px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.load-more-communities-btn:hover {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1215px) {\r\n  .sort-controls > button:not(.display-settings-btn) {\r\n    display: none;\r\n  }\r\n\r\n  .sort-dropdown {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media (max-width: 1100px) and (min-width: 769px) {\r\n  .communities-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n  .communities-grid.list-view {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .community-list-container {\r\n    padding: 16px;\r\n  }\r\n\r\n  .communities-header {\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .communities-title {\r\n    font-size: 24px;\r\n  }\r\n\r\n  .communities-controls {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .communities-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 16px;\r\n  }\r\n\r\n  .community-card {\r\n    padding: 16px;\r\n  }\r\n}\r\n\n/* Search Input Styling */\n.community-search-container {\n  padding: 1rem 1rem 0 1rem;\n}\n\n.community-search-input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--border-color, #333);\n  border-radius: 8px;\n  background: var(--bg-secondary, #1a1a1a);\n  color: var(--text-primary, #fff);\n  font-size: 1rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.community-search-input:focus {\n  outline: none;\n  border-color: var(--accent-color, #e31337);\n  box-shadow: 0 0 0 2px rgba(227, 19, 55, 0.2);\n}\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
